/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Empty_BodyInputs */

const en_history_empty_body = /** @type {(inputs: History_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you cook lands here: at the end of cooking mode, marked cooked in the plan, or with “Log” on a recipe.`)
};

const de_history_empty_body = /** @type {(inputs: History_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ihr kocht, landet hier: am Ende des Kochmodus, im Plan als gekocht markiert oder über „Eintragen“ im Rezept.`)
};

/**
* | output |
* | --- |
* | "What you cook lands here: at the end of cooking mode, marked cooked in the plan, or with “Log” on a recipe." |
*
* @param {History_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_empty_body = /** @type {((inputs?: History_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_empty_body(inputs)
	return en_history_empty_body(inputs)
});